import React, { useEffect, useState } from "react";
import { Moon, AlertTriangle, CheckCircle2 } from "lucide-react";
import api from "../../lib/apiClient";

const FORM_LABEL = { nightgown: "Nightgown", two_piece_pajamas: "Two-piece pajamas", one_piece_or_footed_pajamas: "One-piece / footed pajamas", pajama_set_total: "Pajama set (both)", "": "Unclassified" };

export function SleepwearReadiness() {
  const [rd, setRd] = useState(null);
  useEffect(() => { api.get("/admin/sleepwear/readiness").then(({ data }) => setRd(data)).catch(() => setRd({ error: true })); }, []);
  if (!rd) return <div className="bg-white rounded-2xl border border-line h-32 animate-pulse" data-testid="sleepwear-readiness-loading" />;
  if (rd.error) return <p role="alert" className="text-sm text-brand" data-testid="sleepwear-readiness-error">Sleepwear readiness could not be loaded.</p>;
  const pub = rd.products.filter((p) => p.public);
  return (
    <section className="bg-white rounded-2xl border border-line p-4" data-testid="sleepwear-readiness">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-2">
        <h3 className="font-bold text-ink flex items-center gap-2"><Moon size={16} className="text-brand" /> Girls' sleepwear readiness</h3>
        <span data-testid="sleepwear-readiness-status" className={`text-xs font-bold px-2.5 py-1 rounded-full ${rd.status === "PASS" ? "bg-success/10 text-success" : "bg-gold/15 text-gold-text"}`}>{rd.status}</span>
      </div>
      <p className="text-xs text-ink-soft mb-3">Public sleepwear by retailer-classified form: {Object.entries(rd.public_by_form).map(([k, v]) => `${FORM_LABEL[k]} ${v}`).join(" · ")}. Preference counts (aggregate only): {Object.keys(rd.preference_counts).length ? Object.entries(rd.preference_counts).map(([k, v]) => `${k} ${v}`).join(" · ") : "none yet"}.</p>
      {rd.blockers.length > 0 && (
        <ul className="text-xs space-y-1 mb-3" data-testid="sleepwear-blockers">
          {rd.blockers.map((b, i) => <li key={i} className="flex items-start gap-2 text-ink"><AlertTriangle size={13} className="text-brand mt-0.5 shrink-0" /> {b}</li>)}
        </ul>
      )}
      <div className="grid lg:grid-cols-2 gap-4">
        <div>
          <h4 className="text-xs font-bold uppercase tracking-wider text-ink-muted mb-1.5">Product-source table (public)</h4>
          <ul className="text-xs space-y-1" data-testid="sleepwear-product-table">
            {pub.map((p, i) => (
              <li key={i} className="flex items-start gap-2">
                {p.sleepwear_form ? <CheckCircle2 size={13} className="text-success mt-0.5 shrink-0" /> : <AlertTriangle size={13} className="text-brand mt-0.5 shrink-0" />}
                <span><span className="font-semibold text-ink">{p.name}</span> — {FORM_LABEL[p.sleepwear_form]}{p.evidence?.basis ? ` · ${p.evidence.basis.replace(/_/g, " ")}` : ""}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-wider text-ink-muted mb-1.5">Nightgown chart-source table</h4>
          <ul className="text-xs space-y-1" data-testid="sleepwear-chart-table">
            {rd.chart_sources.map((c) => (
              <li key={c.brand} className="flex items-start gap-2">
                {c.nightgown_chart_approved ? <CheckCircle2 size={13} className="text-success mt-0.5 shrink-0" /> : <AlertTriangle size={13} className="text-brand mt-0.5 shrink-0" />}
                <span><span className="font-semibold text-ink">{c.brand}</span> — {c.nightgown_chart_approved ? "approved nightgown chart" : c.state}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
